var OfferModelV2 = function () {
    var that = this;
    var requestHandle;

    that.AddressModal = ko.observable(null);
    that.Offers = ko.observableArray([]);
    that.SelectedMailHeadType = ko.observable(0);
    that.Working = ko.observable(false);
    that.UserHasMailHead = ko.observable(false);
    that.Amount = ko.observable(0).extend({ rateLimit: { timeout: 400, method: "notifyWhenChangesStop" } });
    that.ShowPrice = ko.observable(false);
    that.GrossPrice = ko.observable();
    that.IsAdvantageousAmountAvailable = ko.observable(false);
    that.NextTopAmount = ko.observable(0);
    that.UserReferenceText = ko.observable("");

    that.ArticleReference = "";
    that.SelectedOrderOptions = [];
    that.SelectedAdditionalWorkIds = [];
    that.SelectedDeliveryCountryId = 0;
    that.IsLoading = ko.observable(false);

    //search offer parameter
    that.OfferId = ko.observable(null);
    that.Email = ko.observable("");
    that.Company = ko.observable("");
    that.LastName = ko.observable("");
    that.Reference = ko.observable("");
    that.ObjectId = ko.observable(0);
    that.Revenue = ko.observable("");
    that.RevenueOperator = ko.observable("");
    that.CurrencyId = ko.observable(null);
    that.OnlyOffersWithoutOrder = ko.observable(false);

    that.IsAmountSetProgrammatically = false;

    that.Amount.subscribe(function () {
        that.IsAdvantageousAmountAvailable(false);
    });

    var abortPendingRequest = function () {
        if (!that.ShowPrice()) {
            requestHandle.abort();
            console.info("aborted call to GetGrossPriceForArticleWithAmount");
        }
    };

    that.Amount.subscribe(function () {
        if (that.IsAmountSetProgrammatically || that.Amount() === 0) {
            that.IsAmountSetProgrammatically = false;
            return;
        }
        abortPendingRequest();
        that.ShowPrice(false);
        that.IsAdvantageousAmountAvailable(false);
        requestHandle = $.ajax({
            url: ajaxUrls.offer.GetGrossPriceForArticleWithAmount,
            type: "POST",
            data: JSON.stringify({
                articleReference: that.ArticleReference,
                amount: that.Amount(),
                selectedOrderOptions: that.SelectedOrderOptions,
                selectedAdditionalWorkIds: that.SelectedAdditionalWorkIds,
                countryId: that.SelectedDeliveryCountryId
            }),
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).done(function (data) {
            if (data.Success) {
                that.ShowPrice(true);
                if (data.data.IsIndividualAmount === true && data.data.NextTopAmount > 0) {
                    that.IsAdvantageousAmountAvailable(true);
                } else {
                    that.IsAdvantageousAmountAvailable(false);
                }
                that.GrossPrice(data.data.GrossPrice);
                that.NextTopAmount(data.data.NextTopAmount);
            }
        });
    });

    var offerModel = function (circulation, price) {
        this.Circulation = ko.observable(circulation);
        this.Price = ko.observable(price);
    };

    that.Clear = function () {
        that.Offers.removeAll();
        that.IsAdvantageousAmountAvailable(false);
        that.ShowPrice(false);
    };

    that.AddOffer = function (circulation, price) {
        that.Offers.push(new offerModel(circulation, price));
    };

    that.AddToOffer = function () {
        var validAmount = true;
        $.each(that.Offers(),
            function (index, offer) {
                if (offer.Circulation() === that.Amount()) {
                    //amount already added
                    validAmount = false;
                }
            });
        if (!validAmount) {
            alerts.warning(constants.offer.DoubleOfferAmountError);
            return;
        }
        that.Working(true);
        $.ajax({
            url: ajaxUrls.offer.AddToOffer,
            type: "POST",
            data: JSON.stringify({
                item: {
                    articleReference: that.ArticleReference,
                    amount: that.Amount(),
                    selectedOrderOptions: that.SelectedOrderOptions,
                    selectedAdditionalWorkIds: that.SelectedAdditionalWorkIds,
                    countryId: that.SelectedDeliveryCountryId
                },
                offerId: that.OfferId
            }),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        }).done(function (data) {
            if (data.Success) {
                that.Offers.push(new offerModel(that.Amount(), that.GrossPrice()));
                that.Working(false);
            } else {
                alerts.error();
            }
        }).fail(function () {
            alerts.error();
        });
    };

    that.RemoveOffer = function (offer) {
        that.Working(true);

        var data = {
            Amount: offer.Circulation(),
            OfferId: that.OfferId
        };

        $.ajax({
            url: ajaxUrls.offer.RemoveAmount,
            type: "POST",
            data: ko.toJSON(data),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        }).fail(function () {
            alerts.error();
        }).always(function () {
            that.Working(false);
        });

        that.Offers.remove(offer);
    };

    that.UpdateData = function (articleReference, amount, selectedOrderOptions, selectedAdditionalWorkIds, selectedDeliveryCountryId, grossPrice) {
        that.Amount(0);
        that.ArticleReference = articleReference;
        that.SelectedOrderOptions = selectedOrderOptions;
        that.SelectedAdditionalWorkIds = selectedAdditionalWorkIds;
        that.IsAmountSetProgrammatically = true;
        that.Amount(parseInt(amount));
        that.SelectedDeliveryCountryId = selectedDeliveryCountryId;
        that.GrossPrice(grossPrice);
        that.ShowPrice(true);
    };

    that.PrintOffer = function (input, event) {
        that.Working(true);
        var target = event.target;
        var isExtended = target.getAttribute("data-extendedprint");
        that.Working(false);
        var link = ajaxUrls.offer.ShowOffer + "/" + that.OfferId;
        window.open(link, "_blank");
    };

    that.ListOffersPartial = function () {
        that.IsLoading(true);
        var listOffersPartialUrl = $("#listOffersPartialUrl").val();
        var params = {
            offerId: that.OfferId(),
            email: that.Email(),
            company: that.Company(),
            lastname: that.LastName(),
            reference: that.Reference(),
            objectId: that.ObjectId(),
            revenue: that.Revenue(),
            revenueOperator: that.RevenueOperator(),
            currencyId: that.CurrencyId(),
            onlyOffersWithoutOrder: that.OnlyOffersWithoutOrder()
        };

        $.ajax({
            url: listOffersPartialUrl,
            type: "GET",
            data: params
        }).done(function (result) {
            $("#OfferResult").html(result);
        }).fail(function (xhr) {
            alerts.error();
        }).always(function () {
            that.IsLoading(false);
        });
    };
};
